import React from 'react';

const P = ({ className }) => (
  <div className={`animate-pulse rounded-md bg-gray-200 ${className}`} />
);

const BlogDetailSkeleton = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 text-[#1f1730]">
    {/* Navbar placeholder */}
    <div className="h-14 w-full animate-pulse bg-white shadow-sm" />

    <section className="mx-auto max-w-7xl overflow-hidden px-4 pb-8 sm:px-6 lg:px-8 mt-4">
      <div className="grid gap-6 lg:grid-cols-[minmax(0,2fr)_minmax(300px,1fr)]">

        {/* Main content */}
        <div className="min-w-0 overflow-hidden rounded-[30px] border border-gray-100 bg-white shadow-sm">

          {/* Header section */}
          <div className="border-b border-gray-100 px-4 py-4 sm:px-6 sm:py-5 lg:px-8">
            {/* Back link */}
            <P className="h-4 w-28" />

            {/* Category + views */}
            <div className="mt-5 flex gap-3">
              <P className="h-6 w-20 rounded-full" />
              <P className="h-6 w-16" />
            </div>

            {/* Title */}
            <div className="mt-4 space-y-2.5">
              <P className="h-8 w-full" />
              <P className="h-8 w-4/5" />
              <P className="h-8 w-3/5" />
            </div>

            {/* Excerpt */}
            <div className="mt-4 space-y-2">
              <P className="h-4 w-full" />
              <P className="h-4 w-11/12" />
              <P className="h-4 w-3/4" />
            </div>

            {/* Meta row — author, read time, stats */}
            <div className="mt-4 flex flex-wrap gap-3">
              <P className="h-7 w-28 rounded-full" />
              <P className="h-7 w-20 rounded-full" />
              <P className="h-7 w-24 rounded-full" />
              <P className="h-7 w-16 rounded-full" />
              <P className="h-7 w-16 rounded-full" />
              <P className="h-7 w-16 rounded-full" />
            </div>
          </div>

          {/* Body section */}
          <div className="px-4 py-4 sm:px-6 sm:py-6 lg:px-8">
            {/* Cover image */}
            <P className="h-[220px] w-full rounded-[26px] sm:h-[300px]" />

            {/* Article content lines */}
            <div className="mt-8 space-y-3">
              {[100, 95, 88, 100, 92, 80, 100, 96, 85, 70, 100, 93, 88, 60].map((w, i) => (
                <P key={i} className="h-4" style={{ width: `${w}%` }} />
              ))}
              {/* Subheading */}
              <P className="mt-6 h-6 w-2/5" />
              {[100, 94, 87, 100, 91, 78, 100, 95].map((w, i) => (
                <P key={`b${i}`} className="h-4" style={{ width: `${w}%` }} />
              ))}
            </div>

            {/* Engagement box */}
            <div className="mt-10 rounded-[28px] border border-[#ece3f8] bg-[#faf8ff] p-5 sm:p-6">
              <P className="h-3 w-24" />
              <P className="mt-2 h-6 w-48" />
              <div className="mt-5 grid grid-cols-4 gap-2">
                {[1, 2, 3, 4].map((n) => (
                  <P key={n} className="h-10 rounded-xl" />
                ))}
              </div>
              {/* Comment textarea */}
              <P className="mt-5 h-28 w-full rounded-[24px]" />
              <div className="mt-3 flex justify-end">
                <P className="h-10 w-32 rounded-2xl" />
              </div>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <aside className="xl:sticky xl:top-6 xl:self-start">
          <div className="rounded-[30px] border border-gray-100 bg-white p-5 shadow-sm sm:p-6">
            <P className="h-3 w-20" />
            <P className="mt-2 h-6 w-32" />
            <div className="mt-5 space-y-4 divide-y divide-[#f0eaf8]">
              {[1, 2, 3].map((n) => (
                <div key={n} className="flex gap-3 pt-4 first:pt-0">
                  <P className="h-16 w-20 shrink-0 rounded-lg" />
                  <div className="flex flex-1 flex-col gap-2 py-1">
                    <P className="h-3.5 w-full" />
                    <P className="h-3.5 w-4/5" />
                    <div className="flex gap-2 mt-1">
                      <P className="h-3 w-10" />
                      <P className="h-3 w-10" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </aside>

      </div>
    </section>
  </div>
);

export default BlogDetailSkeleton;
